import React from 'react'
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { RootState } from '@share/utils';
import { useHistory } from 'react-router-dom';

const ProgramInformation = ({ headerTitle, rows }: any) => {
  const history = useHistory();
  const { account } = useSelector((state: RootState) => state.loginStore);
  const handleNavigate = (url: string) => {
    history.push(`/${account?.name}${url}`);
  }
  return (
  <div className="card shadow-sm border">
    <div className="card-header bg-transparent border-bottom">
      <h4 className="card-header-title"><i className="bi bi-info-circle me-2"></i><FormattedMessage id="program.information" /></h4>
    </div>

    <div className="card-body vstack">
      <ul>
        <li><span className="program-information-link" onClick={() => handleNavigate('/travbusiness-faq')}><FormattedMessage id="faq" /></span></li>
        <li><span className="program-information-link" onClick={() => handleNavigate('/travbusiness-how-program-works')}><FormattedMessage id="how.program.works" /></span></li>
        <li><span className="program-information-link" onClick={() => handleNavigate('/travbusiness-terms-of-use')}><FormattedMessage id="sidekick.rewards.terms.title" /></span></li>
      </ul>
    </div>
  </div>
    
  )
}


export default ProgramInformation